"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("./index");

var _login = require("../login");

var _reducerUtil = _interopRequireDefault(require("../reducerUtil"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Call this to prepare the API calls.
 * @param {string} [host] The host url.
 */
var start = function start(host, gateway, disableRedirect) {
  return function (dispatch) {
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.host, host));
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.gateway, gateway));
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.disableRedirect, disableRedirect));
  };
};
/** This adds new headers.
 * @param {object} [newHeaders] An object containing new headers.
 */


var addHeaders = function addHeaders(newHeaders) {
  return function (dispatch, getState) {
    var headers = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.headers, getState()) || {};
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.headers, _objectSpread(_objectSpread({}, headers), newHeaders)));
  };
};
/** This removes old headers.
 * @param {string|[string]} [oldHeaders] A single header or list of headers to remove.
 */


var removeHeaders = function removeHeaders(oldHeaders) {
  return function (dispatch, getState) {
    if (!Array.isArray(oldHeaders)) oldHeaders = [oldHeaders];
    var headers = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.headers, getState()) || {};
    var newHeaders = {};
    Object.keys(headers).filter(function (key) {
      return !oldHeaders.includes(key);
    }).forEach(function (key) {
      newHeaders[key] = headers[key];
    });
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.headers, newHeaders));
  };
};
/** This handles get requests.
 * @param {string} [endpoint] The endpoint.
 * @param {boolean} [gateway] Does it use the gateway?
 * @returns {promise} The api request.
 */


var get = function get(endpoint, gateway) {
  return function (dispatch) {
    return dispatch(apiCall(endpoint, 'GET', undefined, gateway));
  };
};
/** This handles post requests.
 * @param {string} [endpoint] The endpoint.
 * @param {object} [body] The body object or formdata.
 * @param {boolean} [gateway] Does it use the gateway?
 * @returns {promise} The api request.
 */


var post = function post(endpoint, body, gateway) {
  return function (dispatch) {
    return dispatch(apiCall(endpoint, 'POST', body, gateway));
  };
};
/** This handles put requests.
 * @param {string} [endpoint] The endpoint.
 * @param {object} [body] The body object or formdata.
 * @param {boolean} [gateway] Does it use the gateway?
 * @returns {promise} The api request.
 */


var put = function put(endpoint, body, gateway) {
  return function (dispatch) {
    return dispatch(apiCall(endpoint, 'PUT', body, gateway));
  };
};
/** This handles patch requests.
 * @param {string} [endpoint] The endpoint.
 * @param {object} [body] The body object or formdata.
 * @param {boolean} [gateway] Does it use the gateway?
 * @returns {promise} The api request.
 */


var patch = function patch(endpoint, body, gateway) {
  return function (dispatch) {
    return dispatch(apiCall(endpoint, 'PATCH', body, gateway));
  };
};
/** This handles delete requests.
 * @param {string} [endpoint] The endpoint.
 * @param {object} [body] The body object or formdata.
 * @param {boolean} [gateway] Does it use the gateway?
 * @returns {promise} The api request.
 */


var apiDelete = function apiDelete(endpoint, body, gateway) {
  return function (dispatch) {
    return dispatch(apiCall(endpoint, 'DELETE', body, gateway));
  };
};
/** This handles post file requests.
 * @param {string} [endpoint] The endpoint.
 * @param {object} [body] The body object or formdata.
 * @param {boolean} [gateway] Does it use the gateway?
 * @returns {promise} The api request.
 */


var postFile = function postFile(endpoint, body, gateway) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var fileCount, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // check queue
              fileCount = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.fileCount, getState()) || 0;

            case 1:
              if (!(fileCount >= _utils.maxFiles)) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return new Promise(function (resolve) {
                return setTimeout(resolve, _utils.fileDelay);
              });

            case 4:
              fileCount = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.fileCount, getState()) || 0;
              _context.next = 1;
              break;

            case 7:
              // add to queue
              dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.fileCount, fileCount + 1)); // make the call

              _context.next = 10;
              return dispatch(apiCall(endpoint, 'POST', body, gateway));

            case 10:
              result = _context.sent;
              // remove from queue
              fileCount = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.fileCount, getState()) || 0;
              dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.fileCount, fileCount - 1)); // return result

              return _context.abrupt("return", result);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
/** This handles the REST api calls.
 * @param {string} [endpoint] The endpoint.
 * @param {string} [method] The http method.
 * @param {object} [body] The body object or formdata.
 * @param {boolean} [gateway] Does it use the gateway?
 * @returns {promise} The api request.
 */


var apiCall = function apiCall(endpoint, method, body, gateway) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var host, state, loginRequired, token, config, response, contentType, disableRedirect, url;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              host = dispatch(getHost(gateway));

              if (host) {
                _context2.next = 3;
                break;
              }

              throw new Error('host url required');

            case 3:
              state = getState();
              loginRequired = _reducerUtil["default"].getSlice(_index.reducerData, _login.reducerData.loginRequired, state);
              token = _reducerUtil["default"].getSlice(_login.reducerData, _login.reducerData.token, state);

              if (!(loginRequired && !token)) {
                _context2.next = 8;
                break;
              }

              throw new Error('login token required');

            case 8:
              config = {
                method: method,
                headers: dispatch(getHeaders())
              };

              if (body) {
                if (body instanceof FormData) {
                  config.body = body;
                } else {
                  config.headers['Content-Type'] = 'application/json';
                  config.body = typeof body === 'string' ? body : JSON.stringify(body);
                }
              }

              _context2.next = 12;
              return fetch("".concat(host, "/").concat(endpoint), config);

            case 12:
              response = _context2.sent;

              if (!response.ok) {
                _context2.next = 30;
                break;
              }

              contentType = response.headers.get('content-type');

              if (!(contentType && contentType.includes('application/json'))) {
                _context2.next = 21;
                break;
              }

              _context2.next = 18;
              return response.json();

            case 18:
              return _context2.abrupt("return", _context2.sent);

            case 21:
              if (!(contentType && contentType.includes('text/html'))) {
                _context2.next = 25;
                break;
              }

              _context2.next = 24;
              return response.text();

            case 24:
              return _context2.abrupt("return", _context2.sent);

            case 25:
              _context2.next = 27;
              return response.blob();

            case 27:
              return _context2.abrupt("return", _context2.sent);

            case 30:
              if (!(response.status === 302)) {
                _context2.next = 40;
                break;
              }

              disableRedirect = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.disableRedirect, state);

              if (!disableRedirect) {
                _context2.next = 34;
                break;
              }

              throw response;

            case 34:
              _context2.next = 36;
              return response.json();

            case 36:
              url = _context2.sent;
              window.location.replace(url);
              _context2.next = 41;
              break;

            case 40:
              throw response;

            case 41:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/** This returns the header object */


var getHeaders = function getHeaders() {
  return function (dispatch, getState) {
    var state = getState();

    var token = _reducerUtil["default"].getSlice(_login.reducerData, _login.reducerData.token, state);

    var headers = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.headers, state) || {};
    return _objectSpread({
      Authorization: token ? "Bearer ".concat(token) : undefined
    }, headers);
  };
};
/** This returns the host url
 * @param {boolean} [gateway] Does it use the gateway?
 */


var getHost = function getHost(gateway) {
  return function (dispatch, getState) {
    if (gateway) return _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.gateway, getState());
    return _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.host, getState());
  };
};

var _default = {
  start: start,
  addHeaders: addHeaders,
  removeHeaders: removeHeaders,
  get: get,
  post: post,
  postFile: postFile,
  put: put,
  patch: patch,
  "delete": apiDelete,
  getHost: getHost,
  getHeaders: getHeaders
};
exports["default"] = _default;